'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { fetchCertificadoAcessos } from '../store/certificados/actions';
import { selectCertificadoAcessos, selectCertificadoAcessosError, selectCertificadoAcessosLoading } from '../store/certificados/selectors';
import { clearCertificadoAcessos } from '../store/certificados/slice';
import type { OrigemCertificadoAcessos } from '../types/certificadoAcessosTypes';
import { useBaixarPdfCertificadoAcessos } from './useBaixarPdfCertificadoAcessos';
export function useCertificadoAcessosPage(processoId, t0) {
  const $ = _c(16);
  const origem = t0 === undefined ? "parte" : t0;
  const dispatch = useAppDispatch();
  const certificado = useAppSelector(selectCertificadoAcessos);
  const isLoading = useAppSelector(selectCertificadoAcessosLoading);
  const error = useAppSelector(selectCertificadoAcessosError);
  const t1 = certificado?.numeroProcesso ?? null;
  let t2;
  if ($[0] !== origem || $[1] !== processoId || $[2] !== t1) {
    t2 = {
      processoId,
      origem,
      numeroProcesso: t1
    };
    $[0] = origem;
    $[1] = processoId;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    isDownloadingPdf,
    baixarPdf,
    abortarDownload
  } = useBaixarPdfCertificadoAcessos(t2);
  let t3;
  let t4;
  if ($[4] !== abortarDownload || $[5] !== dispatch || $[6] !== origem || $[7] !== processoId) {
    t3 = () => {
      if (!processoId) {
        return;
      }
      dispatch(fetchCertificadoAcessos({
        processoId,
        origem
      }));
      return () => {
        abortarDownload();
        dispatch(clearCertificadoAcessos());
      };
    };
    t4 = [abortarDownload, dispatch, processoId, origem];
    $[4] = abortarDownload;
    $[5] = dispatch;
    $[6] = origem;
    $[7] = processoId;
    $[8] = t3;
    $[9] = t4;
  } else {
    t3 = $[8];
    t4 = $[9];
  }
  useEffect(t3, t4);
  let t5;
  if ($[10] !== baixarPdf || $[11] !== certificado || $[12] !== error || $[13] !== isDownloadingPdf || $[14] !== isLoading) {
    t5 = {
      certificado,
      isLoading,
      error,
      isDownloadingPdf,
      baixarPdf
    };
    $[10] = baixarPdf;
    $[11] = certificado;
    $[12] = error;
    $[13] = isDownloadingPdf;
    $[14] = isLoading;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
}